var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWindowJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#10DB9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 24C19.75 23.3096 20.3096 22.75 21 22.75H43C43.6904 22.75 44.25 23.3096 44.25 24V40.2222C44.25 40.9126 43.6904 41.4722 43 41.4722H21C20.3096 41.4722 19.75 40.9126 19.75 40.2222V24ZM21 21.25C19.4812 21.25 18.25 22.4812 18.25 24V40.2222C18.25 41.741 19.4812 42.9722 21 42.9722H43C44.5188 42.9722 45.75 41.741 45.75 40.2222V24C45.75 22.4812 44.5188 21.25 43 21.25H21ZM24.0885 27.0008C24.4579 26.5903 24.4247 25.958 24.0141 25.5886C23.6036 25.2191 22.9714 25.2524 22.6019 25.6629L22.5887 25.6775C22.2193 26.088 22.2526 26.7203 22.6631 27.0898C23.0736 27.4592 23.7059 27.4259 24.0753 27.0154L24.0885 27.0008ZM26.9048 25.5886C27.3153 25.958 27.3486 26.5903 26.9791 27.0008L26.966 27.0154C26.5965 27.4259 25.9642 27.4592 25.5537 27.0898C25.1432 26.7203 25.1099 26.088 25.4794 25.6775L25.4925 25.6629C25.862 25.2524 26.4943 25.2191 26.9048 25.5886ZM29.8678 27.0008C30.2372 26.5903 30.204 25.958 29.7934 25.5886C29.3829 25.2191 28.7506 25.2524 28.3812 25.6629L28.368 25.6775C27.9986 26.088 28.0319 26.7203 28.4424 27.0898C28.8529 27.4592 29.4852 27.4259 29.8546 27.0154L29.8678 27.0008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWindowJoin);
export default __webpack_public_path__ + "static/media/ic_window_join.744bbaec82db50dcbe715c440b6bf9ae.svg";
export { ForwardRef as ReactComponent };